
'use client';

import { useState, useEffect } from 'react';
import { useTheme } from 'next-themes';
import { Moon, Sun, Monitor } from 'lucide-react';

export default function ThemeToggle() {
    const [mounted, setMounted] = useState(false);
    const { theme, setTheme } = useTheme();

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return <div className="w-8 h-8" />; // Avoid hydration mismatch
    }

    return (
        <button
            onClick={() => {
                if (theme === 'dark') setTheme('light');
                else if (theme === 'light') setTheme('system');
                else setTheme('dark');
            }}
            className="w-9 h-9 flex items-center justify-center rounded-lg border border-[var(--color-border)] text-[var(--color-text-muted)] hover:text-[var(--color-primary)] hover:border-[var(--color-primary)] transition-all bg-[var(--bg-elevated)]"
            aria-label="Toggle Theme"
        >
            {theme === 'dark' ? (
                <Moon size={18} />
            ) : theme === 'light' ? (
                <Sun size={18} />
            ) : (
                <Monitor size={18} />
            )}
        </button>
    );
}
